import './SubscriberStatsRow.scss';
import React, { FunctionComponent, memo } from 'react';
import { Grid, GridItem } from 'plume-ui';
import { subscriberStatFixtures } from '../fixtures';
import { combineSubscriberStats } from '../../../helpers';
import HeroStatsCell from '../../../../HealthSummary/components/HeroStatsCell/HeroStatsCell';
import { HeroStatType } from '../../../../HealthSummary/services/heroStatsProc';

type SubscriberStatProps = {
  values: number[];
  ready: boolean;
};

const SubscriberStatsRow: FunctionComponent<SubscriberStatProps> = ({
  values,
  ready,
}) => {
  const stats = combineSubscriberStats(values, subscriberStatFixtures);
  return (
    <div className="SubscriberStatsRow">
      <div className="SubscriberStatsRow__Grid">
        <Grid>
          {stats.map((stat: HeroStatType, id: number) => (
            <GridItem
              colSpan="12"
              tabletColSpan="12"
              key={`filterTreeKey-${id}`}
            >
              <HeroStatsCell
                key={stat.id || stat.label}
                label={stat.label}
                value={values[id]}
                ready={ready}
              />
            </GridItem>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default memo(SubscriberStatsRow);
